import { Feature } from '@otto-ec/tracking-bct';

export const getProductFeaturesForNonPdpPage = (variationId: string): Feature[] => {
    const productFeatureId = `P_${variationId}`;
    const businessDimensionFeatureId = `BD_${variationId}`;
    const variationFeatureId = `V_${variationId}`;

    return [
        {
            id: productFeatureId,
            name: 'Product',
            status: 'visible',
        },
        {
            id: businessDimensionFeatureId,
            parentId: productFeatureId,
            name: 'Business-Dimension',
            status: 'visible',
            labels: {},
        },
        {
            id: variationFeatureId,
            parentId: businessDimensionFeatureId,
            name: 'Variation',
            status: 'visible',
            variationId,
            labels: {},
        },
    ];
};
